var App = App || {};

App.PageMasthead = (function ($) {
    'use strict';

    function init() {
        var $pageMasthead = $(".page-masthead"),

            $video = $pageMasthead.find(".video"),
            $controls = $pageMasthead.find(".controls"),
            $play = $controls.find(".fa-play"),
            $pause = $controls.find(".fa-pause"),

            $ul = $pageMasthead.find(".rich-text ul");

        if ($pageMasthead && $video && $controls) {
            $controls.on("click", function () {
                $video.each(function (i) {
                    var video = $video[i];

                    if (video.paused == true) {
                        video.play();

                        $play
                            .addClass("d-none")
                            .removeClass("d-block");

                        $pause
                            .addClass("d-block")
                            .removeClass("d-none");
                    }
                    else {
                        video.pause();

                        $play
                            .addClass("d-block")
                            .removeClass("d-none");

                        $pause
                            .addClass("d-none")
                            .removeClass("d-block");
                    }
                });
            });
        }

        if ($ul) {
            var children = $ul.find("li");

            if (children.length % 2 !== 0) {
                $ul.append("<li class=\"invisible p-0\"></li>");
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.PageMasthead.init();
});